export const utils = {
  capitalize,
  renderImage
};

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function renderImage(name) {
  // return `https://storage.googleapis.com/pn-storages/${name}`;
  // return `https://pns.sgp1.cdn.digitaloceanspaces.com/${name}`;

  return `https://spaces.propnavigation.com/${name}`;
}

// https://pn-storages.sgp1.cdn.digitaloceanspaces.com/dev/1-%2840%29-_1637141491.jpeg

// https://spaces.propnavigation.com/dev/1-%2840%29-_1637141491.jpeg

// https://pn-storages.sgp1.digitaloceanspaces.com/dev/1-%2840%29-_1637141491.jpeg